import { useEffect, useRef } from 'react';
import { useBaseElement } from './useElement';
import TileLayer from 'ol/layer/Tile';
import { useOpenLayersContext } from './OpenLayersContext';

interface WMSTileLayerProps {
  tileLayer: TileLayer<any>;
}

export function WMSTileLayer({ tileLayer }: WMSTileLayerProps) {
  const elementRef = useRef(tileLayer);

  useBaseElement(elementRef.current, 'wmsBase');

  return null;
}
